import { useEffect, useState } from "react";
import { useDashboardSettings } from "../../../../Context/DashboardSettingProvider";

const useCheckDisplayChart = (chartKey) => {
  const { dashboardAccrdion } = useDashboardSettings();
  const [displayChart, setDisplayChart] = useState(false);

  useEffect(() => {
    const findeChart = dashboardAccrdion.find(
      (item) => item.chart === chartKey
    );
    if (findeChart) {
      setDisplayChart(findeChart.value);
    }
  }, [dashboardAccrdion]);

  return { displayChart };
};
export default useCheckDisplayChart;
